import { observable } from 'mobx';

export type ETicketResponseArgs = {
  id: number;
  link: string;
};

export type ETicketArgs = {
  id: number;
  link: string;
};

export const convertETicketResponseToArgs = (response: ETicketResponseArgs) => {
  const args: ETicketArgs = {
    id: response.id,
    link: response.link
  };
  return args;
};

export default class ETicket {
  @observable id: number;
  @observable link: string;

  constructor(args: ETicketArgs) {
    this.id = args.id;
    this.link = args.link;
  }
}
